import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import {assert} from 'Asserts';
import * as NavConstants from 'constants/NavConstants';
import * as SidepanelActions from 'nav/sidepanel/SidepanelActions';
import * as Colors from 'ui-library/Colors';
import SectionTabs from 'ui-library/SectionTabs';
import {assertNever} from 'util/Types';

import RequestV2DefinitionListing from './RequestV2DefinitionListing';
import RequestsV2SubmissionListing from './RequestV2SubmissionListing';

type ValidSections =
  | NavConstants.Section.REQUESTS_V2_DEFINITIONS
  | NavConstants.Section.REQUESTS_V2_SUBMISSIONS;

interface SidepanelProps {
  activeSection: ValidSections;
  activeItemId: string | null;
  isCompactDisplay: boolean;
  setIsCompactDisplay: (isCompact: boolean) => void;
  isExpanded: boolean;
}

export default function RequestsV2Sidepanel(props: SidepanelProps): JSX.Element {
  const tabs = [
    {
      handleClick: () => {
        SidepanelActions.openSection(NavConstants.Section.REQUESTS_V2_DEFINITIONS);
      },
      isActive: props.activeSection === NavConstants.Section.REQUESTS_V2_DEFINITIONS,
      text: 'Request Types',
    },
    {
      handleClick: () => {
        SidepanelActions.openSection(NavConstants.Section.REQUESTS_V2_SUBMISSIONS);
      },
      isActive: props.activeSection === NavConstants.Section.REQUESTS_V2_SUBMISSIONS,
      text: 'Dashboard',
    },
  ];

  const requestsV2Tab = <SectionTabs className={css(styles.sectionTabs)} tabs={tabs} />;

  switch (props.activeSection) {
    case NavConstants.Section.REQUESTS_V2_SUBMISSIONS:
      return (
        <RequestsV2SubmissionListing
          isCompactDisplay={props.isCompactDisplay}
          setIsCompactDisplay={props.setIsCompactDisplay}
          isExpanded={props.isExpanded}
          activeItemId={props.activeItemId}
          requestsV2Tab={requestsV2Tab}
        />
      );
    case NavConstants.Section.REQUESTS_V2_DEFINITIONS:
      return (
        <RequestV2DefinitionListing
          isCompactDisplay={props.isCompactDisplay}
          setIsCompactDisplay={props.setIsCompactDisplay}
          isExpanded={props.isExpanded}
          activeItemId={props.activeItemId}
          requestsV2Tab={requestsV2Tab}
        />
      );
    default:
      assert(false, `Invalid section: ${assertNever(props.activeSection)}`);
      return <div />;
  }
}
const styles = StyleSheet.create({
  sectionTabs: {
    borderBottomColor: Colors.GRAY,
    borderBottomWidth: 1,
    borderBottomStyle: 'solid',
    margin: '0 -12px',
  },
});
